import axios from "axios";

export const getCategoriesApi = (payload) => {
  // console.log(payload, "get payload")
  const prodUrl = process.env.REACT_APP_BASE_URL;
  return (
    axios
      .get(prodUrl + `inventory-service/api/v1/${payload}/`)
      // .get("https://jsonplaceholder.typicode.com/posts")
      .then(function (response) {
        // console.log(response)
        return response;
      })
      .catch((error) => {
        console.log(error);
        return error;
      })
  );
};
